import { createStore, applyMiddleware, combineReducers, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { keaSaga, keaReducer } from 'kea'

const reducers = combineReducers({
  scenes: keaReducer('scenes')
})

const sagaMiddleware = createSagaMiddleware()

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const finalCreateStore = composeEnhancers(
  applyMiddleware(sagaMiddleware)
 // more middlewares here
)(createStore)

const store = finalCreateStore(reducers)

sagaMiddleware.run(keaSaga)

export default store



// WEBPACK FOOTER //
// ./src/store.js